import { SVGProps } from "react";

export default function XMarkIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 16, width = 16, fill = "black", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M14.063 3.40023L12.5964 1.93359L7.99634 6.60026L3.39632 1.93359L1.92969 3.40023L6.59635 8.00024L1.92969 12.6003L3.39632 14.0669L7.99634 9.40023L12.5964 14.0669L14.063 12.6003L9.39632 8.00024L14.063 3.40023Z"
        fill={fill}
      />
    </svg>
  );
}
